import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { Templates } from './templates';

const WrappedPage = withAuth(Templates);
const WrappedTemplatesView = withLayout(LayoutType.WithNavOnly, WrappedPage);

export { WrappedTemplatesView as Templates };
